<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-primary">
  <div class="d-flex flex-nowrap align-items-center">
    <app-brand-container />
  </div>
  <div class="d-flex justify-content-end">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
      [class.open]="!collapsed()"
      (click)="toggleCollapsed()"
    >
      <i class="fa fa-ellipsis-v"></i>
    </button>
  </div>

  <div
    class="navbar-collapse collapse show"
    [class.in]="!collapsed()"
    id="navbarSupportedContent"
  >
    <ul class="navbar-nav mr-auto"></ul>
    <ul class="navbar-nav float-lg-right">
      <li class="nav-item d-lg-none d-xl-none">
        <a class="nav-link" routerLink="/home/news" routerLinkActive="active"
          >Sporty's News</a
        >
      </li>
      @if (!!config() && config()['user.mode'] === 'PAID') {
      <li class="nav-item">
        <a class="nav-link" routerLink="/home/courses" routerLinkActive="active"
          >My Courses</a
        >
      </li>
      } @if (!!config() && config()['user.mode'] === 'PAID') {
      <li class="nav-item">
        <a class="nav-link" routerLink="/home/learn" routerLinkActive="active"
          >All Courses</a
        >
      </li>
      } @if (!!config() && config()['user.mode'] === 'PAID') {
      <li class="nav-item">
        <a class="nav-link" routerLink="/home/learn-to-fly" routerLinkActive="active"
          >Learn To Fly</a
        >
      </li>
      }
    </ul>
  </div>
</nav>

<p class="description-text">Sorry, the page you were looking for was not found!</p>

<p class="redirect-text">Search for it again or try one of Sporty's wide variety of aviation training courses, including pilot training, avionics eLearning, aircraft transition and flight currency.</p>

<a
  routerLink="/home/learn"
  class="btn btn-round btn-lg btn-shadow btn-primary btn-width-fixed-240"
  >Discover Sporty's Courses</a
>
